<template>
    <div class="rating-stars">
        <span class="rating-stars__number">
            <common-info-tip :showIcon="false">
                <template #content>
                    {{ rating ? Number(rating).toFixed(1) : 'N/A' }}
                </template>
                <template>
                    {{ $t('elements.home.rating.heading.medmatch.info') }}
                </template>
            </common-info-tip>
        </span>
        <div>
            <ul class="rating-stars__stars">
                <li v-for="i in 5" :key="i" :class="starClass(i)">
                    <svg><use xlink:href="#icon-star" /></svg>
                </li>
            </ul>
            <span v-if="enableViewDetails" class="rating-stars__link" @click="$emit('viewDetailsClicked', {})">View details</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rating: { type: [String, Number], default: undefined },
            enableViewDetails: { type: Boolean, default: false },
        },

        methods: {
            starClass(index) {
                return {
                    'rating-stars__star': true,
                    'rating-stars__star--on': index <= Math.round(this.rating),
                }
            },
        },
    }
</script>
